/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button, DialogActions } from "@mui/material";
import { LinkEditContext } from "cms/links/link-selector/context/edit";

const LinkDialogBottomActions = () => {
    
    const {
        // link,
        selectedLink,
        handleEditClose,
        onSaveLink,
        canSave,
        setCanSave,
    } = useContext(LinkEditContext);
    
    const cancelDisabled = false;
    const handleSave = () => {
        onSaveLink(selectedLink);
    };
    const handleCancel = (e) => {
        setCanSave(false);
        handleEditClose(e);
    };
    return (
        <DialogActions className="simplicity-link-selector-window-footer">
            <Button
                variant='outlined'
                color='secondary'
                onClick={handleCancel}
                disabled={cancelDisabled}
            >
                Cancel
            </Button>
            {canSave &&
                <>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </>
            }
            {!canSave &&
                <>
                    <Button
                        variant='contained'
                        color='grey'
                        onClick={handleSave}
                        disabled={true}
                    >
                        Save
                    </Button>
                </>
            }
        </DialogActions>
    );
};

export { LinkDialogBottomActions };
